import React from "react";

export default function BellIconWhite() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <path
        d="M8.93816 0C7.08165 0 5.30117 0.737498 3.98842 2.05025C2.67566 3.36301 1.93816 5.14348 1.93816 7V10.528C1.93831 10.6831 1.90236 10.8362 1.83316 10.975L0.116163 14.408C0.0322892 14.5757 -0.00731514 14.7621 0.00111129 14.9494C0.00953771 15.1368 0.0657151 15.3188 0.164308 15.4783C0.262901 15.6379 0.400635 15.7695 0.56443 15.8608C0.728224 15.9521 0.912641 16 1.10016 16H16.7762C16.9637 16 17.1481 15.9521 17.3119 15.8608C17.4757 15.7695 17.6134 15.6379 17.712 15.4783C17.8106 15.3188 17.8668 15.1368 17.8752 14.9494C17.8836 14.7621 17.844 14.5757 17.7602 14.408L16.0442 10.975C15.9746 10.8362 15.9383 10.6832 15.9382 10.528V7C15.9382 5.14348 15.2007 3.36301 13.8879 2.05025C12.5752 0.737498 10.7947 0 8.93816 0ZM8.93816 19C8.31751 19.0003 7.71204 18.8081 7.20518 18.4499C6.69833 18.0917 6.31505 17.5852 6.10816 17H11.7682C11.5613 17.5852 11.178 18.0917 10.6711 18.4499C10.1643 18.8081 9.55882 19.0003 8.93816 19Z"
        fill="white"
      />
    </svg>
  );
}
